import React, { useState } from "react";
import {
    addMovementPoint,
    getMovementHistory,
} from "../services/movementAnalyticsService";

import { MapContainer, TileLayer, Marker, Polyline } from "react-leaflet";
import L from "leaflet";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl:
        "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png",
    iconUrl:
        "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png",
    shadowUrl:
        "https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png",
});
const MovementAnalyticsPage = () => {
    const [deviceId, setDeviceId] = useState(1);
    const [lat, setLat] = useState("");
    const [lng, setLng] = useState("");
    const [history, setHistory] = useState([]);

    const addPoint = async () => {
        await addMovementPoint(deviceId, lat, lng);
    };

    const loadHistory = async () => {
        const data = await getMovementHistory(deviceId);
        setHistory(data);
    };

    // convert to map format
    const positions = history.map(p => [p.latitude, p.longitude]);

    return (
        <div>
            <h2>Movement Analytics (Map)</h2>

            <input value={deviceId} onChange={e => setDeviceId(e.target.value)} />
            <input value={lat} onChange={e => setLat(e.target.value)} placeholder="Lat" />
            <input value={lng} onChange={e => setLng(e.target.value)} placeholder="Lng" />

            <button onClick={addPoint}>Add Point</button>
            <button onClick={loadHistory}>Load Route</button>

            <div style={{ height: "500px", marginTop: "20px" }}>
                <MapContainer
                    center={[50.45, 30.52]} // ���� (������ ��������)
                    zoom={10}
                    style={{ height: "100%", width: "100%" }}
                >
                    <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />

                    {/* ����� */}
                    {positions.map((pos, i) => (
                        <Marker key={i} position={pos} />
                    ))}

                    {/* ����� �������� */}
                    {positions.length > 1 && (
                        <Polyline positions={positions} color="blue" />
                    )}
                </MapContainer>
            </div>
        </div>
    );
};

export default MovementAnalyticsPage;